module.exports = __webpack_public_path__ + "img/14.c10f51c7.png";